import { useState, useMemo } from "react";
import { Container, Grid, Stack, Typography, Card, Skeleton, Button, IconButton, Box } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import axios from "axios";

import Modal from "Components/Modal";

import { API_URL, BASE_URL } from "Constants";
import { useQuery } from "react-query";

type ContentType = "Ping reduction service" | "dns";
interface IContent {
  current_page: number;
  picture: string;
  text: string;
  type: ContentType;
}
interface IItem {
  id: number;
  icon: string;
  name: string;
  data: IContent[];
  color: string;
  total_dns_content: number;
  total_ping_content: number;
}

const CONTENTS_BUTTON: { name: string; value: ContentType }[] = [
  { name: "DNS", value: "dns" },
  { name: "سرویس ویژه", value: "Ping reduction service" },
];

export default function HowToUse() {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [activeContent, setActiveContent] = useState<ContentType>("dns");
  const [contentPage, setContentPage] = useState<number>(1);
  const [modalData, setModalData] = useState<IItem | null>(null);

  const { data, isLoading } = useQuery({
    queryKey: ["trainings"],
    queryFn: (): Promise<IItem[]> => axios.get(`${API_URL}/trainings`).then((res) => res.data),
  });

  const totalContent = activeContent === "dns" ? modalData?.total_dns_content : modalData?.total_ping_content;

  const handleRenderContent = () => {
    if (modalData === null) return;
    const content = modalData.data.filter((i) => i.type === activeContent)[contentPage - 1];

    if (!content)
      return (
        <Typography align="center" variant="h6">
          داده ای موجود نیست!
        </Typography>
      );
    return (
      <>
        <img src={`${BASE_URL}${content.picture}`} alt="content img" style={{ width: "100%", borderRadius: "10px" }} />

        <p style={{ width: "100%", fontSize: "18px", marginTop: "20px" }}>{content.text}</p>
      </>
    );
  };
  const handleShowData = (item: IItem) => {
    toggleModal();
    setModalData(item);
  };
  const toggleModal = () => {
    setShowModal((prev) => !prev);
    setContentPage(1);
  };

  const renderItems = useMemo(() => {
    return data?.map((i) => (
      <Grid item xs={12} md={6}>
        <Button fullWidth sx={{ p: 0, borderRadius: "15px" }} onClick={() => handleShowData(i)}>
          <Card sx={{ px: 3, position: "relative", width: "100%" }}>
            <Stack direction="row" spacing={3} alignItems="center" justifyContent="center" sx={{ height: "130px" }}>
              <img src={`${BASE_URL}${i.icon}`} width="60px" />

              <Typography
                sx={{
                  color: i.color,
                  fontSize: { xs: "30px", md: "40px" },
                  fontWeight: "600",
                  lineHeight: "30px",
                  textTransform: "none",
                }}
              >
                آموزش {i.name}
              </Typography>
            </Stack>
          </Card>
        </Button>
      </Grid>
    ));
  }, [data]);
  const renderLoadingItems = useMemo(() => {
    return Array.from({ length: 4 }).map((i) => (
      <Grid item xs={12} md={6}>
        <Skeleton variant="rectangular" width="100%" height="130px" sx={{ borderRadius: 3 }} />
      </Grid>
    ));
  }, []);

  return (
    <>
      <Modal open={showModal} onClose={toggleModal} size="md">
        <>
          <Stack alignItems="center" mb={3}>
            <Card sx={{ bgcolor: "primary.main", p: 0.5, borderRadius: "50px" }}>
              {CONTENTS_BUTTON.map((item) => (
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: "50px",
                    minWidth: "100px",
                    fontSize: "16px",
                    bgcolor: item.value === activeContent ? "#5479bc !important" : "transparent",
                  }}
                  onClick={() => {
                    setActiveContent(item.value);
                    setContentPage(1);
                  }}
                >
                  {item.name}
                </Button>
              ))}
            </Card>
          </Stack>

          <Box sx={{ maxHeight: "60vh", overflowY: "scroll", pr: 1, mb: 2 }}>{handleRenderContent()}</Box>

          <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
            <IconButton disabled={totalContent === contentPage} onClick={() => setContentPage((prev) => prev + 1)}>
              <ArrowForwardIosIcon fontSize="small" />
            </IconButton>

            <Typography fontFamily="sans-serif">
              {contentPage}/{totalContent}
            </Typography>

            <IconButton disabled={contentPage === 1} onClick={() => setContentPage((prev) => prev - 1)}>
              <ArrowBackIosNewIcon fontSize="small" />
            </IconButton>
          </Stack>
        </>
      </Modal>

      <Container maxWidth="lg">
        <Grid container columnSpacing={5} rowGap={5}>
          {isLoading ? renderLoadingItems : renderItems}
        </Grid>
      </Container>
    </>
  );
}
